module.exports = __webpack_public_path__ + "img/apple3.ca252e8c.png";